import React, {Component, type ReactNode} from 'react'
import * as Sentry from '@sentry/react'

type ErrorBoundaryWrapperProps = {
  children: ReactNode;
  onError?: (error: Error, componentStack: string, eventId: string) => void;
  FallbackComponent?: React.ComponentType<{
    error: Error;
    info: React.ErrorInfo;
    clearError: () => void;
  }>;
};

export class ErrorBoundaryWrapper extends Component<
  ErrorBoundaryWrapperProps,
unknown> {
  render() {
    const {children, FallbackComponent, onError} = this.props

    const fallback = FallbackComponent
      ? ({error, componentStack, resetError}: {error: Error; componentStack: string | null; resetError: () => void}) => (
        <FallbackComponent
          error={error}
          info={{componentStack: componentStack ?? ''} as React.ErrorInfo}
          clearError={resetError}
        />
      )
      : undefined

    return (
      <Sentry.ErrorBoundary fallback={fallback as any} onError={onError}>
        {children}
      </Sentry.ErrorBoundary>
    )
  }
}
